<template>
    <section class="section generate pb-0">
        <div class="container">
            <div class="row items-gap">
                <div class="col-12 col-lg-6 col-xl-5">
                    <div class="generate__content wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <div class="section__header text-start">
                            <h2 class="h2">
                                {{ labelsState['automate_your_customer_services'] || 'Automate your customer service 24/7' }}
                                {{ labelsState['connect_business'] || 'Connect your business and your customers with' }}
                                <span class="grd">{{ labelsState['nqa_chatbot'] || 'NQA ChatBot' }}</span>
                            </h2>
                        </div>
                        <div>
                            <div class="generate__content-btn generate__content-btn-active">
                                <div class="thumb">
                                    <i class="tech-pen"></i>
                                </div>
                                <div class="content">
                                    <h5 class="h5">{{ labelsState['custom_chat'] || 'Custom Chat' }}</h5>
                                    <p>{{ labelsState['custom_chat_description'] || "Customize your chat to your company's brand identity" }}</p>
                                </div>
                            </div>
                            <div class="generate__content-btn">
                                <div class="thumb">
                                    <i class="tech-cart"></i>
                                </div>
                                <div class="content">
                                    <h5 class="h5">{{ labelsState['ecommerce_growth'] || 'Growing your eCommerce' }}</h5>
                                    <p>{{ labelsState['ecommerce_growth_description'] || "Improve your customers' experience and increase your sales" }}</p>
                                </div>
                            </div>
                            <div class="generate__content-btn">
                                <div class="thumb">
                                    <i class="tech-mike"></i>
                                </div>
                                <div class="content">
                                    <h5 class="h5">{{ labelsState['social_connection'] || 'Connection with Networks' }}</h5>
                                    <p>{{ labelsState['social_connection_description'] || 'Integrate all your customer service channels' }}</p>
                                </div>
                            </div>                            
                            <div class="generate__content-btn">
                                <div class="thumb">
                                    <i class="tech-globe"></i>
                                </div>
                                <div class="content">
                                    <h5 class="h5">{{ labelsState['join_revolution'] || 'Join the Revolution' }}</h5>
                                    <p>{{ labelsState['join_revolution_description'] || 'With Artificial Intelligence you can take your business to another level' }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 col-xl-7">
                    <div class="generate__thumb wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <div class="tab-content active">
                            <img :src="require('@/assets/images/generate/custom-chat.png')" alt="image">
                        </div>
                        <div class="tab-content">
                            <img :src="require('@/assets/images/generate/growing.png')" alt="image">
                        </div>
                        <div class="tab-content">
                            <img :src="require('@/assets/images/generate/conection.png')" alt="image">
                        </div>
                        <div class="tab-content">
                            <img :src="require('@/assets/images/generate/revolution.png')" alt="image">
                        </div>   
                        <div class="anime anime--light">
                            <img :src="require('@/assets/images/anime-four.png')" alt="Image">
                        </div>
                    </div>
                </div>
            </div>
        </div>       
    </section>
</template>

<script>
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';
import { computed, onMounted } from 'vue';
import axios from 'axios';

export default {
    name: "Generate",
    setup() {
        const labelsStore = useLabelsStore();
        const languageStore = useLanguageStore();

        const changeLanguage = (languageCode) => {
            labelsStore.fetchAndSetLabels(languageCode);
        };

        const labelsState = computed(() => labelsStore.labels);
        const languageCodes = computed(() => languageStore.codes);

        return {
            labelsState,
            languageCodes,
            changeLanguage,
        };
    },
    mounted() {
        const tabContents = document.querySelectorAll('.tab-content');
        const tabButtons = document.querySelectorAll('.generate__content-btn');
        tabContents[0].style.display = 'block';
        tabButtons[0].classList.add('generate__content-btn-active');
        tabButtons.forEach((button, index) => {
            button.addEventListener('click', () => {
                tabButtons.forEach((btn) => btn.classList.remove('generate__content-btn-active'));
                tabContents.forEach((content) => content.style.display = 'none');
                button.classList.add('generate__content-btn-active');
                tabContents[index].style.display = 'block';
                tabContents[index].style.animation = 'fadeIn 900ms';
            });
        });
    }
};
</script>

<style scoped>
.tab-content {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/page_components/home-2/Generate.vue